import React from 'react'
import LockerMenu from '../../Components/LockerMenu'
import { PageWrapper } from '../../Styles/style'
import Header from '../../Sections/Header'
import About from '../../Sections/About'
import Tokenomics from '../../Sections/Tokenomics'
import Claim from '../../Sections/Claim'
import Footer from '../../Sections/Footer'

const MainPage = (props) => {
  return (
    <PageWrapper>
        <LockerMenu />
        <Header />
        <About />
        <Tokenomics />
        {/* <Roadmap /> */}
        <Claim />
        <Footer />
    </PageWrapper>
  )
}

export default MainPage